<template lang="pug">
  api-form(
    v-model="value"
    ref="apiForm"
    no-reset
    reset-btn
    :initial="initial"
    :fields="fields"
    :method="saveAttrs"
    :btn-props=`{
      btnText: 'Сохранить и продолжить',
      rounded: true,
      color: 'success'
    }`
  )
</template>

<script>
import _ from 'lodash';
import FileInput from '@/components/InputFields/FileInput.vue';
import HintWrap from '@/components/HintWrap.vue';
import MaskaField from '@/components/InputFields/MaskaField.vue';
import UserPrivacyAgreement from '@/components/InputFields/UserPrivacyAgreement.vue';

const userInfoFieldsAlias = ['surname', 'name', 'patronymic'];

const sortAttrs = [...userInfoFieldsAlias, 'sex', 'diploma_surname', 'national', 'birth_date', 'job', 'job_post', 'education_level', 'document_series', 'document_number', 'snils'];

export default {
  props: {
    attributes: { type: Array, required: true },
    method: { type: Function, required: true },
    hasPrivacyAgreement: { type: Boolean, required: false },
    course: { type: Object, default: null },
    noDisableAttrs: { type: Boolean, required: false },
  },
  data: () => ({
    value: {},
    userInfoFieldIds: [],
  }),
  computed: {
    fields() {
      const snilsField = (i) => ({
        text: `${i.name} ${i.is_required ? '*' : ''}`,
        value: i.id.toString(),
        rules: i.is_required ? 'required|length:14|snils' : 'length:14|snils',
        component: HintWrap,
        component_attrs: {
          component: MaskaField,
          type: 'snils',
          returnMasked: true,
          hintDescription: i.description,
          rounded: true,
          filled: true,
        },
      });
      const getField = {
        [this.$conf.INPUT_TYPES.number]: (i) => ({
          text: `${i.name} ${i.is_required ? '*' : ''}`,
          value: i.id.toString(),
          rules: i.is_required ? 'required' : 'required',
          component: HintWrap,
          component_attrs: {
            component: 'v-text-field',
            hintDescription: i.description,
            rounded: true,
            filled: true,
            type: 'number',
          },
        }),
        [this.$conf.INPUT_TYPES.text]: (i) => ({
          text: `${i.name} ${i.is_required ? '*' : ''}`,
          value: i.id.toString(),
          rules: i.is_required ? 'required' : 'required',
          component: HintWrap,
          component_attrs: {
            component: 'v-text-field',
            hintDescription: i.description,
            rounded: true,
            filled: true,
          },
        }),
        [this.$conf.INPUT_TYPES.file]: (i) => ({
          text: `${i.name} ${i.is_required ? '*' : ''}`,
          value: i.id.toString(),
          rules: i.is_required ? 'required' : '',
          component: HintWrap,
          component_attrs: {
            component: FileInput,
            rounded: true,
            filled: true,
          },
        }),
        [this.$conf.INPUT_TYPES.list]: (i) => ({
          text: `${i.name} ${i.is_required ? '*' : ''}`,
          value: i.id.toString(),
          rules: i.is_required ? 'required' : '',
          component: HintWrap,
          component_attrs: {
            component: 'v-select',
            hintDescription: i.description,
            items: i.value_options,
            rounded: true,
            filled: true,
          },
        }),
        [this.$conf.INPUT_TYPES.calendar]: (i) => ({
          text: `${i.name} ${i.is_required ? '*' : ''}`,
          value: i.id.toString(),
          rules: i.is_required ? 'required' : '',
          component: 'sdo-datetime-field',
          component_attrs: {
            'only-date': true,
            'label-date': i.name,
          },
        }),
      };
      const sorted = [...this.attributes].reduce((acc, attr) => {
        const sortIndex = sortAttrs.indexOf(attr.alias);
        if (sortIndex === -1) acc[1].push(attr);
        else acc[0][sortIndex] = attr;
        return acc;
      }, [[], []]).flat();

      const attrs = sorted.map((i) => (i.alias === 'snils' ? snilsField(i) : getField[i.type](i)));
      if (this.hasPrivacyAgreement) {
        attrs.push({
          text: 'Пользовательское соглашение',
          value: 'privacy-agreement',
          rules: 'required',
          local: true,
          component: UserPrivacyAgreement,
          component_attrs: {
            attributes: this.attributes,
            organization: this.course && this.course.organization,
          },
        });
      }
      return attrs;
    },
  },
  watch: {
    attributes() {
      this.parseUserAttrs();
      this.$nextTick(() => {
        this.$refs.apiForm.reset();
      });
    },
  },
  created() {
    this.parseUserAttrs();
  },
  methods: {
    parseUserAttrs() {
      this.attributes.forEach((attr) => {
        if (userInfoFieldsAlias.includes(attr.alias)) this.userInfoFieldIds[attr.alias] = attr.id;
        this.value[attr.id] = attr.value;
      });
      this.initial = { ...this.value };
    },
    saveAttrs({ data, obs }) {
      const { isListener, isTeacher, isStudent } = this.$user;
      if (isListener || isTeacher || isStudent) this.saveUserInfo(data);
      const result = _.differenceWith(
        Object.entries(data), Object.entries(this.initial),
        _.isEqual,
      ).filter(([, value]) => !!value);
      const attributes = result.map(([id, value]) => ({ id, value }));
      return this.method({ attributes, obs });
    },
    async saveUserInfo(data) {
      const payload = {
        information_surname: data[this.userInfoFieldIds.surname],
        information_first_name: data[this.userInfoFieldIds.name],
        information_patronymic: data[this.userInfoFieldIds.patronymic],
      };
      await this.$api.users.saveUserSettings(payload);
      await this.$user.syncUser();
    },
  },
};
</script>
